/**
 * @purpose: Bagging Detail modal controller - display comprehensive bagging information
 * @called_by: manifest.bagging.view.ctrl.js via modalFactory.open()
 * @deps: AngularJS app, urlServices, toaster, $uibModalInstance, params
 * @public: modalBaggingDetailCtrl
 * @side_effects: loads bagging detail from API and displays in modal
 */
app.controller('modalBaggingDetailCtrl', ['$scope', '$uibModalInstance', 'urlServices', 'toaster', 'params',
    function($scope, $uibModalInstance, urlServices, toaster, params) {

    // Initialize scope
    $scope.bagId = params && params.bagId ? params.bagId : '';
    $scope.loading = true;
    $scope.error = null;
    $scope.header = null;
    $scope.items = [];
    $scope.summaryByDestination = [];

    /**
     * Load bagging detail from API
     */
    $scope.loadDetail = function() {
        if (!$scope.bagId) {
            $scope.loading = false;
            $scope.error = 'Bag ID tidak ditemukan';
            return;
        }

        $scope.loading = true;
        $scope.error = null;

        urlServices.ambilData('api/bagging-entry/' + encodeURIComponent($scope.bagId), {}, function(err, result) {
            $scope.loading = false;

            if (err) {
                $scope.error = typeof err === 'string' ? err : (err.err || err.message || 'Gagal memuat detail bagging');
                toaster.pop('error', 'Error', $scope.error);
                return;
            }

            if (!result) {
                $scope.error = 'Data bagging tidak ditemukan';
                return;
            }

            $scope.header = result.header || result;
            $scope.items = result.items || [];
            $scope.summaryByDestination = result.summaryByDestination || [];
        });
    };

    /**
     * Close modal
     */
    $scope.close = function() {
        $uibModalInstance.dismiss('cancel');
    };

    // Load data on initialization
    $scope.loadDetail();
}]);
